














import {
  Component,
  Prop,
  Watch,
  Vue,
  Emit
} from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class VirtualScroller extends Vue {

  @Prop({ default: 'vertical' }) 
  orientation: string;

  @Prop({ default: ()=> null }) 
  items: Array<any>;

  @Prop({ default: ()=> null }) 
  columns: Array<any>;

  @Prop({ default: 0 }) 
  itemSize: Number | Array<any>;

  @Prop({ default: null }) 
  numToleratedItems: Number = null;

  @Prop({ default: false }) 
  loading: Boolean = false;

  @Prop({ default: false }) 
  lazy: Boolean;

  @Prop({ default: null }) 
  scrollWidth: Number;

  @Prop({ default: null }) 
  scrollHeight: Number;

  @Prop({ default: false }) 
  showLoader: Boolean;

  @Prop({ default: true }) 
  showSpacer: Boolean;


  @Watch("items")
  itemsChange(newValue, oldValue) {
    if (!oldValue || oldValue.length !== (newValue || []).length) {
        this.init();
    }
  }

  @Watch("orientation")
  orientationChange() {
    this.lastScrollPos = this.isBoth() ? { top: 0, left: 0 } : 0;
  }

  @Emit('scrollIndexChange')
  scrollIndexChange(state: any) {
    return state
  }

  @Emit('scroll')
  scroll(e: any) {
    return e
  }

  private get element():HTMLElement{
    return this.$refs.elementRef as HTMLElement;
  }

  private get content(){
    return this.$refs.contentRef
  }

  public first:Number| any = this.isBoth()? { rows: 0, cols:0 }: 0;
  public last:Number| any = this.isBoth()? { rows: 0, cols:0 }: 0;
  public lastScrollPos:Number| any = this.isBoth()? { top: 0, left:0 }: 0;
  public numItemsInViewport:Number| any = this.isBoth() ? { rows: 0, cols: 0 } : 0;
  public d_numToleratedItems = this.numToleratedItems;
  public d_loading = this.loading;
  public contentStyle: any = {};
  public spacerStyle: any = {};
  public loaderArr: Array<any>=[];


  public get loadedItems(){
    const items = this.items;
    if (items && !this.d_loading) {
        if (this.isBoth()) {
            return items.slice(this.first.rows, this.last.rows).map(item => this.columns ? item : item.slice(this.first.cols, this.last.cols));
        }
        else if (this.isHorizontal() && this.columns)
            return items;
        else
            return items.slice(this.first, this.last);
    }
    return [];
  }

  public get contentClass() {
      return ['p-virtualscroller-content', {
          'p-virtualscroller-loading': this.d_loading
      }];
  }

  public get loaderClass() {
      return ['p-virtualscroller-loader', {
          'p-component-overlay': !this.$slots.loader
      }];
  }

  public get containerClass() {
      return ['p-virtualscroller', {
          'p-both-scroll': this.isBoth(),
          'p-horizontal-scroll': this.isHorizontal()
      }, null];
  }

  beforeCreate() {
  }
  beforeDestroy() {
  }

  public mounted() {
    this.init();
    this.lastScrollPos = this.isBoth() ? { top: 0, left: 0 } : 0;
  }

  public init(){
    this.setSize();
    this.calculateOptions();
    this.setSpacerSize();
  }

  public onScroll(event){
    // this.$emit('scroll', event);
    this.scroll(event);
    this.onScrollChange(event);
  }

  isBoth() {
      return this.orientation === 'both';
  }

  isVertical() {
      return this.orientation === 'vertical';
  }
  isHorizontal() {
      return this.orientation === 'horizontal';
  }

  onScrollChange(event) {
      const { first, last, isRangeChanged, scrollPos } = this.onScrollPositionChange(event);
      if (isRangeChanged) {
          const newState = { first, last };
          this.setContentPosition(newState);
          this.first = first;
          this.last = last;
          this.lastScrollPos = scrollPos;
          // this.$emit('scroll-index-change', newState);
          this.scrollIndexChange(newState);
          if (this.lazy) {
              this.$emit('lazy-load', newState);
          }
      }
  }

  onScrollPositionChange(event) {
    const target = event.target;
    const both = this.isBoth();
    const horizontal = this.isHorizontal();
    const contentPos = this.getContentPosition();
    const calculateScrollPos = (_pos, _cpos) => _pos ? (_pos > _cpos ? _pos - _cpos : _pos) : 0;
    const calculateCurrentIndex = (_pos, _size) => Math.floor(_pos / (_size || _pos));
    const calculateTriggerIndex = (_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) => {
        return (_currentIndex <= _numT ? _numT : (_isScrollDownOrRight ? (_last - _num - _numT) : (_first + _numT - 1)))
    };
    const calculateFirst = (_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) => {
        if (_currentIndex <= _numT)
            return 0;
        else
            return Math.max(0, _isScrollDownOrRight ?
                    (_currentIndex < _triggerIndex ? _first : _currentIndex - _numT) :
                    (_currentIndex > _triggerIndex ? _first : _currentIndex - (2 * _numT)));
    };

    const calculateLast = (_currentIndex, _first, _last, _num, _numT, _isCols=false) => {
        let lastValue = _first + _num + (2 * _numT);
        if (_currentIndex >= _numT) {
            lastValue += (_numT + 1);
        }
        return this.getLast(lastValue, _isCols);
    };

    const scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
    const scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
    let newFirst = both ? { rows: 0, cols: 0 } : 0;
    let newLast = this.last;
    let isRangeChanged = false;
    let newScrollPos = this.lastScrollPos;
    if (both) {
        const isScrollDown = this.lastScrollPos.top <= scrollTop;
        const isScrollRight = this.lastScrollPos.left <= scrollLeft;
        const currentIndex = { rows: calculateCurrentIndex(scrollTop, this.itemSize[0]), cols: calculateCurrentIndex(scrollLeft, this.itemSize[1]) };
        const triggerIndex = {
            rows: calculateTriggerIndex(currentIndex.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], isScrollDown),
            cols: calculateTriggerIndex(currentIndex.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], isScrollRight)
        };
        newFirst = {
            rows: calculateFirst(currentIndex.rows, triggerIndex.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], isScrollDown),
            cols: calculateFirst(currentIndex.cols, triggerIndex.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], isScrollRight)
        };
        newLast = {
            rows: calculateLast(currentIndex.rows, newFirst.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0]),
            cols: calculateLast(currentIndex.cols, newFirst.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], true)
        };
        isRangeChanged = (newFirst.rows !== this.first.rows || newLast.rows !== this.last.rows) || (newFirst.cols !== this.first.cols || newLast.cols !== this.last.cols);
        newScrollPos = { top: scrollTop, left: scrollLeft };
    }
    else {
        const scrollPos = horizontal ? scrollLeft : scrollTop;
        const isScrollDownOrRight = this.lastScrollPos <= scrollPos;
        const currentIndex = calculateCurrentIndex(scrollPos, this.itemSize);
        const triggerIndex = calculateTriggerIndex(currentIndex, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, isScrollDownOrRight);
        newFirst = calculateFirst(currentIndex, triggerIndex, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, isScrollDownOrRight);
        newLast = calculateLast(currentIndex, newFirst, this.last, this.numItemsInViewport, this.d_numToleratedItems);
        isRangeChanged = newFirst !== this.first || newLast !== this.last;
        newScrollPos = scrollPos;
    }
    return {
        first: newFirst,
        last: newLast,
        isRangeChanged,
        scrollPos: newScrollPos
    }
  }
  getContentPosition() {
      if (this.content) {
          const style = getComputedStyle(this.content as Element);
          const left = parseInt(style.paddingLeft, 10) + Math.max(parseInt(style.left, 10), 0);
          const right = parseInt(style.paddingRight, 10) + Math.max(parseInt(style.right, 10), 0);
          const top = parseInt(style.paddingTop, 10) + Math.max(parseInt(style.top, 10), 0);
          const bottom = parseInt(style.paddingBottom, 10) + Math.max(parseInt(style.bottom, 10), 0);
          return { left, right, top, bottom, x: left + right, y: top + bottom };
      }
      return { left: 0, right: 0, top: 0, bottom: 0, x: 0, y: 0 };
  }

  getLast(last = 0, isCols) {
      if (this.items) {
          return Math.min((isCols ? (this.columns || this.items[0]).length : this.items.length), last);
      }
      return 0;
  }

  setContentPosition(pos) {
      if (this.content) {
          const both = this.isBoth();
          const horizontal = this.isHorizontal();
          const first = pos ? pos.first : this.first;
          const calculateTranslateVal = (_first, _size) => (_first * _size);
          const setTransform = (_x = 0, _y = 0) => {
              this.contentStyle = { ...this.contentStyle, ...{ transform: `translate3d(${_x}px, ${_y}px, 0)` } };
          };
          if (both) {
              setTransform(calculateTranslateVal(first.cols, this.itemSize[1]), calculateTranslateVal(first.rows, this.itemSize[0]));
          }
          else {
              const translateVal = calculateTranslateVal(first, this.itemSize);
              horizontal ? setTransform(translateVal, 0) : setTransform(0, translateVal);
          }
      }
  }

  getOptions(renderedIndex) {
      const count = (this.items || []).length;
      const index = this.isBoth() ? this.first.rows + renderedIndex : this.first + renderedIndex;
      return {
          index,
          count,
          first: index === 0,
          last: index === (count - 1),
          even: index % 2 === 0,
          odd: index % 2 !== 0
      };
  }

  setSize() {
      if (this.element) {
          const both = this.isBoth();
          const horizontal = this.isHorizontal();
          const parentElement = (this.element).parentElement;
          const width = this.scrollWidth || `${(this.element.offsetWidth || parentElement.offsetWidth)}px`;
          const height = this.scrollHeight || `${(this.element.offsetHeight || parentElement.offsetHeight)}px`;
          const setProp = (_name, _value) => this.element.style[_name] = _value;
          if (both || horizontal) {
              setProp('height', height);
              setProp('width', width);
          }
          else {
              setProp('height', height);
          }
      }
  }

  calculateOptions() {
      const both = this.isBoth();
      const first = this.first;
      const { numItemsInViewport, numToleratedItems } = this.calculateNumItems();
      const calculateLast = (_first, _num, _numT, _isCols=false) => this.getLast(_first + _num + ((_first < _numT ? 2 : 3) * _numT), _isCols);
      const last = both ?
          { rows: calculateLast(first.rows, (numItemsInViewport as any).rows, numToleratedItems[0]), 
            cols: calculateLast(first.cols, (numItemsInViewport as any).cols, numToleratedItems[1], true) } :
          calculateLast(first, numItemsInViewport, numToleratedItems);
      this.last = last;
      this.numItemsInViewport = numItemsInViewport;
      this.d_numToleratedItems = numToleratedItems as Number;
      this.$emit('update:numToleratedItems', this.d_numToleratedItems);
      if (this.showLoader) {
          this.loaderArr = both ?
              Array.from({ length: (numItemsInViewport as any).rows }).map(() => Array.from({ length: (numItemsInViewport as any).cols })) :
              Array.from({ length: numItemsInViewport as number });
      }
      if (this.lazy) {
          this.$emit('lazy-load', { first, last });
      }
  }

  calculateNumItems() {
        const both = this.isBoth();
        const horizontal = this.isHorizontal();
        const itemSize = this.itemSize;
        const contentPos = this.getContentPosition();
        const contentWidth = this.element ? this.element.offsetWidth - contentPos.left : 0;
        const contentHeight = this.element ? this.element.offsetHeight - contentPos.top : 0;
        const calculateNumItemsInViewport = (_contentSize, _itemSize) => Math.ceil(_contentSize / (_itemSize || _contentSize));
        const calculateNumToleratedItems = (_numItems) => Math.ceil(_numItems / 2);
        const numItemsInViewport = both ?
            { 
              rows: calculateNumItemsInViewport(contentHeight, itemSize[0]), 
              cols: calculateNumItemsInViewport(contentWidth, itemSize[1]) 
            } :
            calculateNumItemsInViewport((horizontal ? contentWidth : contentHeight), itemSize);
        const numToleratedItems = this.d_numToleratedItems || (both ?
            [calculateNumToleratedItems((numItemsInViewport as any).rows), calculateNumToleratedItems((numItemsInViewport as any).cols)] :
            calculateNumToleratedItems(numItemsInViewport));
        return { numItemsInViewport, numToleratedItems };
    }


    setSpacerSize() {
      const items = this.items;
      if (items) {
          const both = this.isBoth();
          const horizontal = this.isHorizontal();
          const contentPos = this.getContentPosition();
          const setProp = (_name, _value, _size, _cpos = 0) => this.spacerStyle = { ...this.spacerStyle, ...{ [`${_name}`]: (((_value || []).length * _size) + _cpos) + 'px' } };
          if (both) {
              setProp('height', items, this.itemSize[0], contentPos.y);
              setProp('width', (this.columns || items[1]), this.itemSize[1], contentPos.x);
          }
          else {
              horizontal ? setProp('width', (this.columns || items), this.itemSize, contentPos.x) : setProp('height', items, this.itemSize, contentPos.y);
          }
      }
    }


    getRenderedRange() {
        const calculateFirstInViewport = (_pos, _size) => Math.floor(_pos / (_size || _pos));
        let firstInViewport = this.first;
        let lastInViewport: any = 0;
        if (this.element) {
            const both = this.isBoth();
            const horizontal = this.isHorizontal();
            const scrollTop = this.element.scrollTop;
            const scrollLeft = this.element.scrollLeft;
            if (both) {
                firstInViewport = { rows: calculateFirstInViewport(scrollTop, this.itemSize[0]), cols: calculateFirstInViewport(scrollLeft, this.itemSize[1]) };
                lastInViewport = { rows: firstInViewport.rows + this.numItemsInViewport.rows, cols: firstInViewport.cols + this.numItemsInViewport.cols };
            }
            else {

                const scrollPos = horizontal ? scrollLeft : scrollTop;
                firstInViewport = calculateFirstInViewport(scrollPos, this.itemSize);
                lastInViewport = firstInViewport + this.numItemsInViewport;
            }
        }
        return {
            first: this.first,
            last: this.last,
            viewport: {
                first: firstInViewport,
                last: lastInViewport
            }
        };
    }


}
